export function registerServiceWorker() {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js", { scope: "/" }).then(registration => {
      // Check for a new application shell whenever the app launches.
      void registration.update();
    }).catch(error => {
      console.warn("Daily Groove service worker registration failed.", error);
    });
  });
}
